import { formatTimeAgoLocalized } from "./dateUtils";

export const getTimeAgoShort = (date: Date) => {
  return formatTimeAgoLocalized(date, "en");
};
